import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTreeModule } from '@angular/material/tree';
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatGridListModule } from '@angular/material/grid-list'
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatBadgeModule } from '@angular/material/badge';

const MatDesign = [
  MatTooltipModule,
  MatButtonModule,
  MatFormFieldModule,
  MatSelectModule,
  MatInputModule,
  MatIconModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatToolbarModule,
  MatMenuModule,
  MatDialogModule,
  MatTreeModule,
  MatCheckboxModule,
  MatGridListModule,
  MatSidenavModule,
  MatExpansionModule,
  MatListModule,
  MatPaginatorModule,
  MatButtonToggleModule,
  MatBadgeModule
];

@NgModule({
  declarations: [],
  imports: [
    MatDesign
  ],
  providers: [
    {
      provide: MatPaginator,
      useValue: {}
    }
 ],
  exports: [
    MatDesign
  ]
})
export class MaterialModule { }
